export default {
  collapse: '收起菜单',
  expand: '展开菜单',
};
